import React from 'react';
import { useField } from 'formik';
import { Checkbox } from '../ui/Checkbox';
import { cn } from '../../utils/cn';

interface CheckboxFormFieldProps {
  name: string;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export const CheckboxFormField: React.FC<CheckboxFormFieldProps> = ({
  name,
  label,
  disabled,
  className,
}) => {
  const [field, meta, helpers] = useField({ name, type: 'checkbox' });
  const hasError = meta.touched && !!meta.error;
  const errorMsg = hasError ? meta.error : null;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="flex items-center gap-2">
        <Checkbox
          id={name}
          data-testid={`checkbox-form-field-${name}`}
          checked={field.value}
          onCheckedChange={(checked) => helpers.setValue(!!checked)}
          disabled={disabled}
          aria-invalid={hasError}
        />
        {label && (
          <label htmlFor={name} className="text-sm text-neutral-700 select-none cursor-pointer">
            {label}
          </label>
        )}
      </div>
      {hasError && <span className="text-destructive text-xs">{errorMsg}</span>}
    </div>
  );
};
